import { ShoppingBag } from "lucide-react";

/** Badge orange « Réservée » */
export function ReservedBadge({ className = "", size = "md", absolute = false }) {
  const sizeCls =
    size === "lg"
      ? "text-xs px-3 py-1.5 gap-1.5"
      : size === "sm"
        ? "text-[10px] px-2 py-0.5 gap-1"
        : "text-[10px] px-2 py-1 gap-1";
  const pos = absolute ? "absolute z-10 top-2 left-2 shadow" : "inline-flex";
  return (
    <span
      data-testid="reserved-badge"
      className={`${pos} inline-flex items-center rounded-sm bg-orange-500 text-white font-bold uppercase tracking-wider ${sizeCls} ${className}`}
    >
      <ShoppingBag className={size === "lg" ? "h-4 w-4" : "h-3 w-3"} />
      Réservée
    </span>
  );
}
